/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOneOptions, FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/groups';

export const GroupApi = {
  selectSupplier: async (option: any) => {
    const url = `${pathname}/select/supplier`;

    const { entityIDs } = option || {};
    try {
      const response = await entityService.post(url, { entityIDs });

      return response;
    } catch (error) {
      throw error;
    }
  },

  selectCustomer: async (option: any) => {
    const url = `${pathname}/select/customer`;

    const { entityIDs } = option || {};
    try {
      const response = await entityService.post(url, { entityIDs });

      return response;
    } catch (error) {
      throw error;
    }
  },

  find: async (option: FindOptions) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithOwnerIDs: async (body: FindGroupWithOwnerIDsBody) => {
    const url = `${pathname}/find-with-owner-ids`;
    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findCustomerGroup: async (option: FilterGroupOptions) => {
    let url = `${pathname}/find-customer-group`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findSupplierGroup: async (option: FilterSupplierGroupOptions) => {
    let url = `${pathname}/find-supplier-group`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicate: async (option?: CheckDuplicateGroupCodeQuery) => {
    let url = `${pathname}/check-duplicate`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  generateCode: async (option: any) => {
    let url = `${pathname}/generate-code`;
    const query = serialize(option || {});
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createCustomerGroup: async (body: any) => {
    const url = `${pathname}/customer-group`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createSupplierGroup: async (body: any) => {
    const url = `${pathname}/supplier-group`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  filter: async (option: FindOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string, option: FindOneOptions) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FilterGroupOptions {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  entityID?: string;
  status?: number;
  type?: number;
}
export interface FilterSupplierGroupOptions {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  entityIDs?: string[];
  status?: number;
  type?: number;
}

export interface FindGroupWithOwnerIDsBody {
  ownerIDs?: string[];
}

export interface CheckDuplicateGroupCodeQuery {
  code: string;
  type: number;
}
